/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2143
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.StartDragEvent = exports.MoveEvent = exports.EndDragEvent = exports.DragAreaChangeEvent = exports.DeleteEvent = exports.ChangeEvent = exports.CreateEvent = exports.BlockEvent = undefined
var r = require(/* 647 */"./647")
Object.defineProperty(exports, "BlockEvent", {
  enumerable: true,
  get: function () {
    return r.BlockEvent
  }
})
var i = require(/* 2144 */"./2144")
Object.defineProperty(exports, "CreateEvent", {
  enumerable: true,
  get: function () {
    return i.CreateEvent
  }
})
var o = require(/* 2149 */"./2149")
Object.defineProperty(exports, "ChangeEvent", {
  enumerable: true,
  get: function () {
    return o.ChangeEvent
  }
})
var a = require(/* 2150 */"./2150")
Object.defineProperty(exports, "DeleteEvent", {
  enumerable: true,
  get: function () {
    return a.DeleteEvent
  }
})
var s = require(/* 2151 */"./2151")
Object.defineProperty(exports, "DragAreaChangeEvent", {
  enumerable: true,
  get: function () {
    return s.DragAreaChangeEvent
  }
})
var c = require(/* 2152 */"./2152")
Object.defineProperty(exports, "EndDragEvent", {
  enumerable: true,
  get: function () {
    return c.EndDragEvent
  }
})
var u = require(/* 2153 */"./2153")
Object.defineProperty(exports, "MoveEvent", {
  enumerable: true,
  get: function () {
    return u.MoveEvent
  }
})
var l = require(/* 2154 */"./2154")
Object.defineProperty(exports, "StartDragEvent", {
  enumerable: true,
  get: function () {
    return l.StartDragEvent
  }
})
